import { PropsWithChildren } from 'react';
import { Container, Title } from './styled';

interface NoticeInterface {
  title?: string;
}

function Notice({ title, children }: PropsWithChildren<NoticeInterface>) {
  return (
    <Container>
      {title && <Title>{title}</Title>}
      {children}
    </Container>
  );
}

export { Notice };
